import { CAPTURE_WORKLET_SOURCE } from "./capture-worklet-source";
import { int16ToBase64 } from "./pcm";
import { LIVE_INPUT_SAMPLE_RATE } from "./protocol";

export class MicCapture {
  private context: AudioContext | null = null;
  private stream: MediaStream | null = null;
  private node: AudioWorkletNode | null = null;

  async start(onChunk: (base64: string) => void): Promise<void> {
    this.stream = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, channelCount: 1 },
    });

    const context = new AudioContext({ sampleRate: LIVE_INPUT_SAMPLE_RATE });
    this.context = context;

    const workletUrl = URL.createObjectURL(
      new Blob([CAPTURE_WORKLET_SOURCE], { type: "application/javascript" }),
    );
    await context.audioWorklet.addModule(workletUrl);
    URL.revokeObjectURL(workletUrl);

    const source = context.createMediaStreamSource(this.stream);
    const node = new AudioWorkletNode(context, "artis-capture-processor");
    node.port.onmessage = (evt: MessageEvent<ArrayBuffer>) => {
      onChunk(int16ToBase64(new Int16Array(evt.data)));
    };
    source.connect(node);
    // Keep the worklet actively pulled by the graph; the processor never
    // writes to its output, so this stays silent — it doesn't monitor the mic.
    node.connect(context.destination);
    this.node = node;
  }

  stop(): void {
    this.node?.port.close();
    this.node?.disconnect();
    this.stream?.getTracks().forEach((track) => track.stop());
    this.context?.close();
    this.node = null;
    this.stream = null;
    this.context = null;
  }
}
